// A collapsed product video must stop playing, including after theme-editor reloads.
document.addEventListener('toggle', (event) => {
  if (event.target.matches?.('details.rpl-product-video') && !event.target.open) {
    event.target.querySelector('video')?.pause();
  }
}, true);

// Compra pelo WhatsApp: quando a variante muda, troca o bloco pelo HTML novo (nome da variante e preço certos na mensagem).
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data || !data.html) return;
    const id = `PlWaBuy-${data.sectionId}`;
    const fresh = data.html.getElementById(id);
    const current = document.getElementById(id);
    if (fresh && current) current.replaceWith(fresh);
  });
}

// Link marcado como indisponível não abre.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[aria-disabled="true"]');
  if (link) event.preventDefault();
});

// No desktop, menu com filhos abre ao passar o mouse.
if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
  document.querySelectorAll('header-menu details, .header__inline-menu details').forEach((details) => {
    let timer;
    details.addEventListener('mouseenter', () => { clearTimeout(timer); details.setAttribute('open', ''); details.querySelector('summary')?.setAttribute('aria-expanded', 'true'); });
    details.addEventListener('mouseleave', () => { timer = setTimeout(() => { details.removeAttribute('open'); details.querySelector('summary')?.setAttribute('aria-expanded', 'false'); }, 120); });
  });
}

// ---------- Rodada 3 (14/10/2026): elementos do Watermelon na cor da Primeira Linha ----------
const plSemMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Carrossel (carousel-navigator e vitrine da Vaer): setas, barrinha de progresso e pontinhos.
function plCarrossel(raiz) {
  const trilho = raiz.querySelector('[data-pl-trilho]');
  if (!trilho || raiz.dataset.plPronto) return;
  raiz.dataset.plPronto = '1';
  const anterior = raiz.querySelectorAll('[data-pl-anterior]');
  const proximo = raiz.querySelectorAll('[data-pl-proximo]');
  const barra = raiz.querySelector('[data-pl-barra]');
  const pontos = raiz.querySelector('[data-pl-pontos]');
  const itens = Array.from(trilho.children);
  if (pontos) pontos.innerHTML = itens.map(() => '<i></i>').join('');
  const atualizar = () => {
    const max = trilho.scrollWidth - trilho.clientWidth;
    const pos = trilho.scrollLeft;
    anterior.forEach((b) => { b.disabled = pos <= 2; });
    proximo.forEach((b) => { b.disabled = pos >= max - 2; });
    if (barra) {
      const parte = trilho.scrollWidth ? trilho.clientWidth / trilho.scrollWidth : 1;
      barra.style.width = `${Math.min(parte, 1) * 100}%`;
      barra.style.transform = `translateX(${max > 0 ? (pos / max) * ((1 / Math.min(parte, 1)) - 1) * 100 : 0}%)`;
    }
    if (pontos) {
      let ativo = 0;
      itens.forEach((item, i) => { if (Math.abs(item.offsetLeft - trilho.offsetLeft - pos) < Math.abs(itens[ativo].offsetLeft - trilho.offsetLeft - pos)) ativo = i; });
      Array.from(pontos.children).forEach((p, i) => p.classList.toggle('is-ativo', i === ativo));
      raiz.plAtivo = ativo;
      raiz.classList.toggle('is-areia', !!itens[ativo]?.classList.contains('pl-banner--areia'));
    }
  };
  const passo = () => Math.max(trilho.clientWidth * 0.85, 200);
  anterior.forEach((b) => b.addEventListener('click', () => trilho.scrollBy({ left: -passo(), behavior: plSemMovimento ? 'auto' : 'smooth' })));
  proximo.forEach((b) => b.addEventListener('click', () => trilho.scrollBy({ left: passo(), behavior: plSemMovimento ? 'auto' : 'smooth' })));
  trilho.addEventListener('scroll', () => requestAnimationFrame(atualizar), { passive: true });
  window.addEventListener('resize', atualizar);
  raiz.plAtualizar = atualizar;
  atualizar();
  // Banners: passam sozinhos; param com mouse em cima, foco dentro, aba escondida ou pedido de menos movimento.
  const segundos = Number(raiz.dataset.plAuto || 0);
  if (segundos > 0 && !plSemMovimento && itens.length > 1) {
    let parado = false;
    const parar = () => { parado = true; };
    const seguir = () => { parado = false; };
    raiz.addEventListener('mouseenter', parar);
    raiz.addEventListener('mouseleave', seguir);
    raiz.addEventListener('focusin', parar);
    raiz.addEventListener('focusout', seguir);
    trilho.addEventListener('touchstart', parar, { passive: true });
    setInterval(() => {
      if (parado || document.hidden) return;
      const prox = ((raiz.plAtivo || 0) + 1) % itens.length;
      trilho.scrollTo({ left: itens[prox].offsetLeft - trilho.offsetLeft, behavior: 'smooth' });
    }, segundos * 1000);
  }
}
document.querySelectorAll('[data-pl-carrossel]').forEach((raiz) => { if (!raiz.hidden) plCarrossel(raiz); });

// Abas da vitrine (fluid-tabs): o fundo carvão desliza até a aba escolhida.
document.querySelectorAll('[data-pl-abas]').forEach((abas) => {
  const fundo = abas.querySelector('[data-pl-abas-fundo]');
  const botoes = Array.from(abas.querySelectorAll('[role="tab"]'));
  const moverFundo = (botao) => {
    if (!fundo || !botao) return;
    fundo.style.width = `${botao.offsetWidth}px`;
    fundo.style.transform = `translateX(${botao.offsetLeft}px)`;
  };
  const escolher = (botao, foco) => {
    botoes.forEach((b) => {
      const sim = b === botao;
      b.setAttribute('aria-selected', sim ? 'true' : 'false');
      b.tabIndex = sim ? 0 : -1;
      const painel = document.getElementById(b.getAttribute('aria-controls'));
      if (painel) painel.hidden = !sim;
      if (sim && painel) { plCarrossel(painel); painel.plAtualizar?.(); }
    });
    moverFundo(botao);
    if (foco) botao.focus();
  };
  botoes.forEach((b, i) => {
    b.addEventListener('click', () => escolher(b));
    b.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      escolher(botoes[(i + (e.key === 'ArrowRight' ? 1 : botoes.length - 1)) % botoes.length], true);
    });
  });
  const ativa = botoes.find((b) => b.getAttribute('aria-selected') === 'true') || botoes[0];
  moverFundo(ativa);
  abas.classList.add('is-pronto');
  window.addEventListener('resize', () => moverFundo(botoes.find((b) => b.getAttribute('aria-selected') === 'true')));
  document.fonts?.ready.then(() => moverFundo(botoes.find((b) => b.getAttribute('aria-selected') === 'true')));
});

// 5 passos: a linha terracota se enche quando a faixa aparece (labeled-progress-indicator).
document.querySelectorAll('[data-pl-passos]').forEach((faixa) => {
  if (plSemMovimento || !('IntersectionObserver' in window)) { faixa.classList.add('is-visivel'); return; }
  const obs = new IntersectionObserver((entradas) => {
    entradas.forEach((en) => { if (en.isIntersecting) { faixa.classList.add('is-visivel'); obs.disconnect(); } });
  }, { threshold: 0.35 });
  obs.observe(faixa);
});

// Produto no celular: barra presa embaixo quando o botão principal sai da tela (scroll-island).
(() => {
  let pedido = false;
  const conferir = () => {
    pedido = false;
    const botao = document.querySelector('[data-pl-compra]');
    const ilha = document.querySelector('[data-pl-ilha]');
    if (!botao || !ilha) return;
    const r = botao.getBoundingClientRect();
    const rodape = document.querySelector('.footer');
    const perto = rodape && rodape.getBoundingClientRect().top < window.innerHeight;
    const mostrar = r.bottom < 0 && !perto;
    ilha.classList.toggle('is-visivel', mostrar);
    ilha.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    ilha.querySelector('a')?.setAttribute('tabindex', mostrar ? '0' : '-1');
  };
  window.addEventListener('scroll', () => { if (!pedido) { pedido = true; requestAnimationFrame(conferir); } }, { passive: true });
})();

// "Mandar para alguém" (share-sheet): copiar o link e fechar o menu ao clicar fora.
document.addEventListener('click', (event) => {
  const copiar = event.target.closest?.('[data-pl-copiar]');
  if (copiar) {
    const texto = copiar.querySelector('[data-pl-copiar-texto]');
    navigator.clipboard?.writeText(copiar.dataset.plCopiar).then(() => {
      if (texto) texto.textContent = 'Link copiado';
      setTimeout(() => { if (texto) texto.textContent = 'Copiar o link'; copiar.closest('details')?.removeAttribute('open'); }, 1600);
    });
    return;
  }
  document.querySelectorAll('details.pl-mandar[open]').forEach((d) => { if (!d.contains(event.target)) d.removeAttribute('open'); });
});

// Rolex por modelo (continuous-tabs): fundo carvão desliza até o modelo; o relógio do modelo troca à direita.
// No computador troca ao passar o mouse; no celular, ao tocar. Setas do teclado também.
document.querySelectorAll('[data-pl-modelos]').forEach((secao) => {
  const lista = secao.querySelector('[data-pl-modelos-lista]');
  const fundo = secao.querySelector('[data-pl-modelos-fundo]');
  const abas = Array.from(secao.querySelectorAll('[role="tab"]'));
  if (!lista || !abas.length) return;
  const mover = (aba) => {
    if (!fundo || !aba) return;
    const deitada = getComputedStyle(lista).flexDirection === 'row';
    if (deitada) {
      fundo.style.width = `${aba.offsetWidth}px`;
      fundo.style.height = '';
      fundo.style.transform = `translateX(${aba.offsetLeft}px)`;
    } else {
      fundo.style.width = '';
      fundo.style.height = `${aba.offsetHeight}px`;
      fundo.style.transform = `translateY(${aba.offsetTop}px)`;
    }
  };
  const escolher = (aba, foco) => {
    abas.forEach((a) => {
      const sim = a === aba;
      a.setAttribute('aria-selected', sim ? 'true' : 'false');
      a.tabIndex = sim ? 0 : -1;
      const painel = document.getElementById(a.getAttribute('aria-controls'));
      if (!painel) return;
      painel.classList.toggle('is-ativo', sim);
      painel.setAttribute('aria-hidden', sim ? 'false' : 'true');
      painel.querySelector('.pl-modelos__botao')?.setAttribute('tabindex', sim ? '0' : '-1');
    });
    mover(aba);
    if (foco) aba.focus();
    if (getComputedStyle(lista).flexDirection === 'row') aba.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: plSemMovimento ? 'auto' : 'smooth' });
  };
  const comMouse = window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
  abas.forEach((a, i) => {
    a.addEventListener('click', () => escolher(a));
    if (comMouse) a.addEventListener('mouseenter', () => escolher(a));
    a.addEventListener('keydown', (e) => {
      const frente = ['ArrowDown', 'ArrowRight'].includes(e.key);
      const tras = ['ArrowUp', 'ArrowLeft'].includes(e.key);
      if (!frente && !tras) return;
      e.preventDefault();
      escolher(abas[(i + (frente ? 1 : abas.length - 1)) % abas.length], true);
    });
  });
  const atual = () => abas.find((a) => a.getAttribute('aria-selected') === 'true') || abas[0];
  mover(atual());
  lista.classList.add('is-pronto');
  window.addEventListener('resize', () => mover(atual()));
  document.fonts?.ready.then(() => mover(atual()));
});

// Contador da quantidade (stepper): o número dá um pulinho quando muda.
document.addEventListener('click', (event) => {
  const botao = event.target.closest?.('.product-form__quantity .quantity__button');
  if (!botao || plSemMovimento) return;
  const campo = botao.closest('.quantity')?.querySelector('.quantity__input');
  if (!campo) return;
  campo.classList.remove('pl-pula');
  void campo.offsetWidth;
  campo.classList.add('pl-pula');
});
